import React from "react";
import { Link } from "react-router-dom";

import GoatFightHeader from "../components/home-page/HomePageHeader";
import GoatFightFooter from "../components/home-page/HomePageFooter";
import golfMatchup from "../assets/images/golf-tiger-vs-nicklaus-final-draft.png";

import "../assets/css/goatfight-home.css";
import "../assets/css/sports-home.css";
import "../assets/css/golf-matchup.css";

const GolfHome = () => (
  <main className="sports-home golf-home">
    <GoatFightHeader />

    <section className="golf-hero">
      <img src={golfMatchup} alt="Tiger Woods versus Jack Nicklaus in a cross-era golf matchup" />
      <div className="golf-hero__overlay" />
      <div className="golf-hero__content">
        <p className="sports-hero__eyebrow">GOLF · CROSS-ERA SIMULATION</p>
        <div className="golf-hero__matchup">TIGER WOODS <span>VS</span> JACK NICKLAUS</div>
        <h1>LEGENDARY PLAYERS.<br />ICONIC COURSES.<br /><span>EVERY SHOT SIMULATED.</span></h1>
        <p>
          Put the greatest golfers from different years head-to-head. GOATFIGHT
          uses historical performance data to play out the matchup shot by shot.
        </p>
        <div className="golf-hero__actions">
          <Link to="/golf/matchup" className="golf-status golf-status--live">PLAY THE MATCHUP</Link>
          <Link to="/" className="golf-back">CHOOSE ANOTHER SPORT</Link>
        </div>
      </div>
    </section>

    <GoatFightFooter />
  </main>
);

export default GolfHome;
